// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"2f444ba0","238":"d28faf09","239":"ec317502","389":"51543290","414":"81a7da6b","455":"8cc8ab9b","488":"01651ff5","857":"2cf59252","977":"c682c8e9"}[chunkId] + ".chunk.js";
};